import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  redirectPath: null,
};

const authRedirectSlice = createSlice({
  name: 'authRedirect',
  initialState,
  reducers: {
    setRedirectPath: (state, action) => {
      state.redirectPath = action.payload;
    },
    clearRedirectPath: (state) => {
      state.redirectPath = null;
    },
  },
});

export const { setRedirectPath, clearRedirectPath } = authRedirectSlice.actions;
export default authRedirectSlice.reducer; 